import axios from "axios";
import { apiBaseUrl } from "@/config/cloudEnv";

let error = 0;
let notificationInterval;

export default {
  namespaced: true,

  state: {
    isNew: false,
  },

  getters: {
    isNew: (state) => state.isNew,
  },

  mutations: {
    setIsNew: (state, isNew) => (state.isNew = isNew),
  },

  actions: {
    init({ dispatch }) {
      if (notificationInterval) return;

      dispatch("fetchIsNewNotification");
      notificationInterval = window.setInterval(async () => {
        dispatch("fetchIsNewNotification");
      }, 3 * 60 * 1000);
    },
    fetchIsNewNotification({ getters, commit, dispatch }) {
      if (!window.navigator.onLine || getters.isNew) return;

      axios
        .get(`${apiBaseUrl()}/notifications/new`, { withCredentials: true })
        .then(({ data: { payload } }) => commit("setIsNew", payload))
        .catch(() => 3 < ++error && dispatch("stopPolling"));
    },
    stopPolling({ commit }) {
      commit("setIsNew", false);
      notificationInterval && clearInterval(notificationInterval);
      notificationInterval = undefined;
      error = 0;
    },
  },
};
